window.addEventListener("load", (event) => {
    // Your code here
    if(!document.querySelectorAll(".carousel.flickity-enabled")) return;
    const sliders = document.querySelectorAll(".carousel.flickity-enabled");
    sliders.forEach(slider => {
        waitForElement('.yotpo-reviews-star-ratings-widget', 500)
        .then((el) => {
            let slides = Array.from(slider.querySelectorAll(".carousel__slide"));
        
            if(!slides) return;

            let heights = slides.map(slide => slide.getBoundingClientRect().height);
            let maxHeight = Math.max(...heights) + 30;

            //console.log("MAX HEIGHT", maxHeight);
            //el.closest('.flickity-enabled').style.minHeight = maxHeight + 'px';

            // const root = document.documentElement;
            // root.style.setProperty('--carousel__slide-height--' + slider.id, maxHeight + 'px');

            if(slider.querySelector('slide-show .flickity-viewport').getBoundingClientRect().height <= maxHeight) {
                slider.querySelector('slide-show .flickity-viewport').style.minHeight = maxHeight + 'px';
                slider.closest('.image-slider-custom').style.minHeight = maxHeight - 30 + 'px';
            }

            
            let difference = 50;
            slider.querySelector('.flickity-prev').style.transform = 'translateY(' + difference + '%)';
            slider.querySelector('.flickity-next').style.transform = 'translateY(' + difference + '%)';
            
        })
        .catch(function(err) {
            return;
            //console.warn(err);
        });
        
        // const root = document.documentElement;
        // root.style.setProperty('--carousel__slide-height', maxHeight + 'px');
    });   
    
    
    function waitForElement(selector , timeout = 10000) {
        return new Promise(function(resolve, reject) {
        const interval = 200; // ms
        const start = Date.now();

        const timer = setInterval(function() {
            let el = document.querySelector(selector);
            if (el) {
                clearInterval(timer);
                resolve(el);
            } else if (Date.now() - start > timeout) {
                clearInterval(timer);
                //reject(new Error('Timed out waiting for ' + selector));
                reject(new Error('Timed out waiting for ' + selector));
            }
        }, interval);
        });
    }
});
